import { render, staticRenderFns } from "./company-deductible.vue?vue&type=template&id=39dc4096&scoped=true"
import script from "./company-deductible.vue?vue&type=script&lang=js"
export * from "./company-deductible.vue?vue&type=script&lang=js"
import style0 from "./company-deductible.vue?vue&type=style&index=0&id=39dc4096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dc4096",
  null
  
)

export default component.exports